import styled from 'styled-components';
import BaseCheckIcon from '#/shared/components/GeneratedIcons/generic/Check';

export const StopAmenitiesListBody = styled.div`
  overflow-y: auto;
  padding: 20px 30px;
`;

export const StopAmenitiesHeader = styled.div`
  color: ${props => props.theme.primaryFontColor};
  font-size: 1.3em;
  margin-bottom: 20px;
`;

export const StopAmenitiesItemContainer = styled.div`
  margin-left: 15px;
`;

export const StopAmenitiesItem = styled.div`
  color: ${props => props.theme.primaryFontColor};
  font-size: 1em;
  margin-bottom: 15px;
`;

export const CheckIcon = styled(BaseCheckIcon).attrs(props => ({
  fill: props.theme.checkMarkColor,
  height: 17,
}))`
  margin-right: 15px;
`;
